import {_utils} from "../../utils/_utils.js";
import {initHeroVideo, playVideo} from "../../utils/hero-video.js";

/**
 * Home page hero:
 * - background video loops muted; plays only while the hero is in view (keeps the user's sound choice)
 * - Sound on / Sound off toggle (label + icon swap, aria-pressed)
 * - rotating badge scrolls to the next section
 */
export const hpHero = () => {
    return new Promise((resolve) => {
        document.querySelectorAll('.hp-hero').forEach((section) => {
            const video = section.querySelector('.hp-hero__video');
            const soundBtn = section.querySelector('.hp-hero__sound');
            const scrollBtn = section.querySelector('.hp-hero__scroll');

            if (video) {
                initHeroVideo(section, video);
                if (soundBtn) initSound(video, soundBtn);
            }

            if (scrollBtn) {
                scrollBtn.addEventListener('click', () => {
                    // On desktop hp-journey pins the hero → ScrollTrigger wraps it in a .pin-spacer,
                    // so the next section is the wrapper's sibling (resolved at click time).
                    const next = (section.closest('.pin-spacer') || section).nextElementSibling;
                    if (next) _utils.scrollToElement(next);
                });
            }
        });

        resolve();
    });
};

const initSound = (video, btn) => {
    const label = btn.querySelector('.hp-hero__sound-label');

    const render = () => {
        const unmuted = !video.muted;
        btn.classList.toggle('is-unmuted', unmuted);
        btn.setAttribute('aria-pressed', unmuted ? 'true' : 'false');
        if (label) label.textContent = unmuted ? btn.dataset.labelOff : btn.dataset.labelOn;
    };

    btn.addEventListener('click', () => {
        video.muted = !video.muted;
        if (!video.muted) playVideo(video);
        render();
    });

    // keep the button in sync if the browser forces mute
    video.addEventListener('volumechange', render);
    render();
};
